'use strict';

module.exports = function asArray(x) {
    if (!x) {
        x = [];
    }

    if (!Array.isArray(x)) {
        x = [x];
    }

    return x;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datagrid/lib/utils/asArray.js
 ** module id = 914
 ** module chunks = 0
 **/